import React from "react";


export const PickMinSlide = () => {
    return (
        <div className="swiper-container pickslide-day-minute">
            <div className="swiper-wrapper">
                <div className="swiper-slide"><span>00</span></div>
                <div className="swiper-slide"><span>01</span></div>
                <div className="swiper-slide"><span>02</span></div>
                <div className="swiper-slide"><span>03</span></div>
                <div className="swiper-slide"><span>04</span></div>
                <div className="swiper-slide"><span>05</span></div>
                <div className="swiper-slide"><span>06</span></div>
                <div className="swiper-slide"><span>07</span></div>
                <div className="swiper-slide"><span>08</span></div>
                <div className="swiper-slide"><span>09</span></div>
                <div className="swiper-slide"><span>10</span></div>
                <div className="swiper-slide"><span>11</span></div>
                <div className="swiper-slide"><span>12</span></div>
                <div className="swiper-slide"><span>13</span></div>
                <div className="swiper-slide"><span>14</span></div>
                <div className="swiper-slide"><span>15</span></div>
                <div className="swiper-slide"><span>16</span></div>
                <div className="swiper-slide"><span>17</span></div>
                <div className="swiper-slide"><span>18</span></div>
                <div className="swiper-slide"><span>19</span></div>
                <div className="swiper-slide"><span>20</span></div>
                <div className="swiper-slide"><span>21</span></div>
                <div className="swiper-slide"><span>22</span></div>
                <div className="swiper-slide"><span>23</span></div>
                <div className="swiper-slide"><span>24</span></div>
                <div className="swiper-slide"><span>25</span></div>
                <div className="swiper-slide"><span>26</span></div>
                <div className="swiper-slide"><span>27</span></div>
                <div className="swiper-slide"><span>28</span></div>
                <div className="swiper-slide"><span>29</span></div>
                <div className="swiper-slide"><span>30</span></div>
                <div className="swiper-slide"><span>31</span></div>
                <div className="swiper-slide"><span>32</span></div>
                <div className="swiper-slide"><span>33</span></div>
                <div className="swiper-slide"><span>34</span></div>
                <div className="swiper-slide"><span>35</span></div>
                <div className="swiper-slide"><span>36</span></div>
                <div className="swiper-slide"><span>37</span></div>
                <div className="swiper-slide"><span>38</span></div>
                <div className="swiper-slide"><span>39</span></div>
                <div className="swiper-slide"><span>40</span></div>
                <div className="swiper-slide"><span>41</span></div>
                <div className="swiper-slide"><span>42</span></div>
                <div className="swiper-slide"><span>43</span></div>
                <div className="swiper-slide"><span>44</span></div>
                <div className="swiper-slide"><span>45</span></div>
                <div className="swiper-slide"><span>46</span></div>
                <div className="swiper-slide"><span>47</span></div>
                <div className="swiper-slide"><span>48</span></div>
                <div className="swiper-slide"><span>49</span></div>
                <div className="swiper-slide"><span>50</span></div>
                <div className="swiper-slide"><span>51</span></div>
                <div className="swiper-slide"><span>52</span></div>
                <div className="swiper-slide"><span>53</span></div>
                <div className="swiper-slide"><span>54</span></div>
                <div className="swiper-slide"><span>55</span></div>
                <div className="swiper-slide"><span>56</span></div>
                <div className="swiper-slide"><span>57</span></div>
                <div className="swiper-slide"><span>58</span></div>
                <div className="swiper-slide"><span>59</span></div>
            </div>
        </div>
    );
};
